// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-products__content-wrapper {
	background-color: white;
	min-height: calc(100vh - 1px);
	display: flex;
	flex-direction: column;
	padding: 18px 24px 24px 0;
	gap: 24px;
}

.my-products__header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-right: 160px;
	gap: 16px;
	width: 100%;
}

.my-products__buttons-wrapper {
	display: flex;
	align-items: center;
	gap: 16px;
}

.my-products__import-export-button {
	width: 44px;
	height: 44px;
	min-width: 44px;
	border: 1px solid #e6e6e6;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 !important;
}

.my-products__bulk-upload-button {
	margin-left: 16px;
}

.my-products__content {
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 12px;
	padding: 24px;
	background-color: #f2f2f2;
	border-radius: 10px;
}

.my-products__table-wrapper {
	background-color: #ffffff;
	padding: 12px;
	border-radius: 10px;
}

.my-products__table-wrapper tr {
	height: 64px;
}

.my-products__table-wrapper tr th {
	font-size: 16px;
	line-height: 20px;
	color: #666666;
	font-weight: 400;
}

.my-products__table-wrapper tr td {
	font-size: 16px;
	line-height: 20px;
	color: #191919;
	font-weight: 400;
}

.my-products__table-wrapper input[type="checkbox"] {
	width: 20px;
	height: 20px;
}

.my-products__filters-wrapper {
	display: flex;
	align-items: center;
	gap: 16px;
}

.my-products__content-filters-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
}

.my-products__variants-table {
	background-color: #f2f2f7;
}

.my-products__status-wrapper {
	display: flex;
	align-items: center;
	gap: 8px;
	justify-content: center;
}

.my-products__status-circle {
	width: 10px;
	height: 10px;
	border-radius: 50%;
}

.my-products__status-circle.blue {
	background-color: #0085ff;
}

.my-products__status-circle.green {
	background-color: #117627;
}

.my-products__status-circle.red {
	background-color: #d24023;
}

.my-products__status-text {
	font-size: 16px;
	line-height: 20px;
	color: #191919;
}

.dropdown-item-hover-green:hover {
	color: white !important;
	background-color: #55bb56;
}

.dropdown-item-hover-blue:hover {
	color: white !important;
	background-color: #4286f4;
}

.dropdown-item-hover-red:hover {
	color: white !important;
	background-color: #dc3545;
}

.nested-table-body td {
	border: none;
}

.rotate-expand-button {
	transform: rotate(90deg);
}

.my-product-details-link {
	color: #5e91dd !important;
	text-decoration: underline !important;
}

.padding-product-nested-table {
	padding-left: 35px !important;
}

.tiktok-status-overlay {
	max-width: 380px;
	background: rgb(20, 20, 20);
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
	padding: 4px 12px;
	border-radius: 8px;
	font-size: 14px;
}

.tiktok-verification-warning {
	background: #fceba1;
	display: flex;
	justify-content: center;
	align-items: center;
	color: #000;
	padding: 4px 12px;
	border-radius: 8px;
	font-size: 14px;
	font-weight: 500;
	display: flex;
	align-items: center;
	gap: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/Dashboard/MyProducts/MyProducts.css"],"names":[],"mappings":"AAAA;CACC,uBAAuB;CACvB,6BAA6B;CAC7B,aAAa;CACb,sBAAsB;CACtB,yBAAyB;CACzB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,oBAAoB;CACpB,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,eAAe;CACf,yBAAyB;CACzB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,qBAAqB;AACtB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;CACX,SAAS;CACT,aAAa;CACb,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,QAAQ;AACT;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,uBAAuB;AACxB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,uBAAuB;CACvB,yBAAyB;AAC1B;;AAEA;CACC,uBAAuB;CACvB,yBAAyB;AAC1B;;AAEA;CACC,uBAAuB;CACvB,yBAAyB;AAC1B;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,yBAAyB;CACzB,qCAAqC;AACtC;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,gBAAgB;CAChB,2BAA2B;CAC3B,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,WAAW;CACX,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,QAAQ;AACT","sourcesContent":[".my-products__content-wrapper {\n\tbackground-color: white;\n\tmin-height: calc(100vh - 1px);\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 18px 24px 24px 0;\n\tgap: 24px;\n}\n\n.my-products__header {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding-right: 160px;\n\tgap: 16px;\n\twidth: 100%;\n}\n\n.my-products__buttons-wrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 16px;\n}\n\n.my-products__import-export-button {\n\twidth: 44px;\n\theight: 44px;\n\tmin-width: 44px;\n\tborder: 1px solid #e6e6e6;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 0 !important;\n}\n\n.my-products__bulk-upload-button {\n\tmargin-left: 16px;\n}\n\n.my-products__content {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\tgap: 12px;\n\tpadding: 24px;\n\tbackground-color: #f2f2f2;\n\tborder-radius: 10px;\n}\n\n.my-products__table-wrapper {\n\tbackground-color: #ffffff;\n\tpadding: 12px;\n\tborder-radius: 10px;\n}\n\n.my-products__table-wrapper tr {\n\theight: 64px;\n}\n\n.my-products__table-wrapper tr th {\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #666666;\n\tfont-weight: 400;\n}\n\n.my-products__table-wrapper tr td {\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #191919;\n\tfont-weight: 400;\n}\n\n.my-products__table-wrapper input[type=\"checkbox\"] {\n\twidth: 20px;\n\theight: 20px;\n}\n\n.my-products__filters-wrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 16px;\n}\n\n.my-products__content-filters-header {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 8px;\n}\n\n.my-products__variants-table {\n\tbackground-color: #f2f2f7;\n}\n\n.my-products__status-wrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n\tjustify-content: center;\n}\n\n.my-products__status-circle {\n\twidth: 10px;\n\theight: 10px;\n\tborder-radius: 50%;\n}\n\n.my-products__status-circle.blue {\n\tbackground-color: #0085ff;\n}\n\n.my-products__status-circle.green {\n\tbackground-color: #117627;\n}\n\n.my-products__status-circle.red {\n\tbackground-color: #d24023;\n}\n\n.my-products__status-text {\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #191919;\n}\n\n.dropdown-item-hover-green:hover {\n\tcolor: white !important;\n\tbackground-color: #55bb56;\n}\n\n.dropdown-item-hover-blue:hover {\n\tcolor: white !important;\n\tbackground-color: #4286f4;\n}\n\n.dropdown-item-hover-red:hover {\n\tcolor: white !important;\n\tbackground-color: #dc3545;\n}\n\n.nested-table-body td {\n\tborder: none;\n}\n\n.rotate-expand-button {\n\ttransform: rotate(90deg);\n}\n\n.my-product-details-link {\n\tcolor: #5e91dd !important;\n\ttext-decoration: underline !important;\n}\n\n.padding-product-nested-table {\n\tpadding-left: 35px !important;\n}\n\n.tiktok-status-overlay {\n\tmax-width: 380px;\n\tbackground: rgb(20, 20, 20);\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tcolor: white;\n\tpadding: 4px 12px;\n\tborder-radius: 8px;\n\tfont-size: 14px;\n}\n\n.tiktok-verification-warning {\n\tbackground: #fceba1;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tcolor: #000;\n\tpadding: 4px 12px;\n\tborder-radius: 8px;\n\tfont-size: 14px;\n\tfont-weight: 500;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
